function tabSetHash(id) {
    if (history.pushState) {
        history.pushState(null, null, id);
    }
    else {
        location.hash = id;
    }
}
function tabToOther(id) {
    $('#tabmenu #' + id).tab('show');
}
(function () {
    const hash = window.location.hash;
    switch (hash) {
        case "#lag":
            tabToOther('tab-btn-team');
            break;
        case "#forening":
            tabToOther('tab-btn-association');
            break;
        case "#butik":
            tabToOther('tab-btn-store');
            break;
    }
    $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
        const target = $(e.target).attr("id");
        switch (target) {
            case "tab-btn-team":
                tabSetHash('#lag');
                break;
            case "tab-btn-association":
                tabSetHash('#forening');
                break;
            case "tab-btn-store":
                tabSetHash('#butik');
                break;
        }
    });
})(jQuery);